import { Component } from '@angular/core';
import { isTestEnvironment } from '@/config/environment.config';

/** Fixer Balken "TESTUMGEBUNG" oben, gleich wie im Keycloak-Theme "cnf-test". Styles: assets/layout/_environment.scss */
@Component({
    selector: 'app-environment-banner',
    standalone: true,
    template: `@if (isTest) {
        <div class="layout-environment-banner" role="status">TESTUMGEBUNG</div>
    }`
})
export class AppEnvironmentBanner {
    readonly isTest = isTestEnvironment();
}
